import { NoteColor } from '@/enums/noteColor';
import type { Size } from '@/types/geometry';

export const MIN_NOTE_SIZE: Size = { width: 120, height: 100 };
export const MAX_NOTE_SIZE: Size = { width: 800, height: 800 };
export const DEFAULT_NOTE_SIZE: Size = { width: 200, height: 180 };

export const MIN_CREATE_DRAG_DISTANCE = 20;

export const NOTE_TEXT_MAX_LENGTH = 2000;

export const DEFAULT_NOTE_COLOR = NoteColor.Yellow;

export const NOTE_PALETTE: readonly NoteColor[] = [
  NoteColor.Yellow,
  NoteColor.Pink,
  NoteColor.Blue,
  NoteColor.Green,
  NoteColor.Purple,
  NoteColor.Orange,
];

export const HISTORY_LIMIT = 20;

export const CACHE_CAPACITY = 500;

export const PERSIST_DEBOUNCE_MS = 300;
export const API_DEBOUNCE_MS = 400;

export const DRAG_CLICK_THRESHOLD_PX = 4;

export const DOUBLE_CLICK_MS = 400;
export const DOUBLE_CLICK_DIST_PX = 6;

export const KEYBOARD_NUDGE_PX = 8;
export const KEYBOARD_NUDGE_LARGE_PX = 32;

export const STRESS_MODE_QUERY_PARAM = 'stress';
